import { getApps, initializeApp } from "@firebase/app"
import { getAuth } from "@firebase/auth";

export default defineNuxtPlugin((nuxtApp) => {
	const config = useRuntimeConfig()
	const firebaseConfig = {
		apiKey: config.public.firebaseApiKey,
		authDomain: config.public.firebaseAuthDomain,
		databaseURL: config.public.firebaseDatabaseUrl,
		projectId: config.public.firebaseProjectId,
		storageBucket: config.public.firebaseStorageBucket,
		messagingSenderId: config.public.firebaseMessagingSenderId,
		appId: config.public.firebaseAppId,
		measurementId: config.public.firebaseMeasurementId
	  };

	//const firebaseConfig = { ...useRuntimeConfig().public.firebaseConfig }

  if (!getApps().length) {
		const app = initializeApp(firebaseConfig)
		const auth = getAuth(app)

		nuxtApp.vueApp.provide('auth', auth)
    	nuxtApp.provide('auth', auth)
		console.log("Firebase initialized")
		//const firestore = getFirestore(app)
	}
})